import React from 'react'

import { Card, Row } from 'antd'
import PT from 'prop-types'

function TrendsCard(props) {
  const { children, dataTestId } = props
  return (
    <Card style={{ marginTop: 30 }} data-testid={dataTestId}>
      <Row style={{ marginBottom: 0 }}>{children}</Row>
    </Card>
  )
}

TrendsCard.propTypes = {
  children: PT.oneOfType([PT.arrayOf(PT.node), PT.node]).isRequired,
  dataTestId: PT.string,
}

export default TrendsCard
